@if (!isClosed) {
    <div class="top-banner" websiteTheme [colorScheme]="bannerColorScheme">
        <div class="wrapper">
            <div class="top-banner__content">
                @if (hasIcon) {
                    <div class="top-banner__icon">
                        @switch (icon) {
                            @case ('heart') {
                                <svg
                                    width="16"
                                    height="16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8 3.625C7.404 2.11 5.736 1 4 1 1.74 1 0 2.69 0 4.938c0 2.928 3.031 5.226 7.291 9.367a1.018 1.018 0 001.418 0C12.969 10.165 16 7.865 16 4.938 16 2.69 14.26 1 12 1c-1.738 0-3.404 1.11-4 2.625z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('thunderbolt') {
                                <svg
                                    width="16"
                                    height="16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M3.481 7.019 10.337.163a.555.555 0 0 1 .92.568L9.774 5.177a1 1 0 0 0 .502 1.21l1.983.993a1 1 0 0 1 .26 1.601l-6.856 6.856a.555.555 0 0 1-.92-.568l1.483-4.446a1 1 0 0 0-.502-1.21L3.741 8.62a1 1 0 0 1-.26-1.601Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('wrikelogofilled') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M3.753 6.367c.774 0 1.14.143 1.7.706l3.01 3.022c.09.09.107.125.125.179.009.018.009.044.009.062 0 .018 0 .045-.01.063-.017.054-.035.09-.124.179l-2.057 2.074c-.089.089-.124.107-.178.125-.018.009-.044.009-.062.009-.018 0-.045 0-.063-.01-.053-.017-.089-.035-.178-.124L.093 6.796c-.169-.17-.107-.429.178-.429h3.482ZM12.247 2.666c-.774 0-1.14.152-1.7.715l-3.01 3.022c-.09.09-.107.125-.125.179-.009.017-.009.044-.009.062 0 .018 0 .045.01.063.017.053.035.09.124.179L9.594 8.95c.089.089.124.107.178.125a.151.151 0 0 0 .062.009c.018 0 .045 0 .063-.01.053-.017.089-.035.178-.124l5.832-5.856c.169-.17.107-.429-.178-.429h-3.482Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('wrikelogolined') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M8.5 10.5l-1.793 1.793a1 1 0 01-1.414 0L3.5 10.5m5 0l6.793-6.793a.707.707 0 00.207-.5v0a.707.707 0 00-.707-.707h-2.879a1 1 0 00-.707.293L6 8m2.5 2.5L6 8m0 0L4.793 6.793a1 1 0 00-.707-.293H1.207a.707.707 0 00-.707.707v0c0 .188.074.367.207.5L3.5 10.5M6 8l-2.5 2.5"
                                        stroke="currentColor"
                                    />
                                </svg>
                            }

                            @case ('settings') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8 0c-.538 0-.987.413-1.031.95l-.004.036c-.04.486-.407.875-.872 1.023a6.247 6.247 0 00-1.016.425c-.429.225-.96.205-1.324-.115l-.022-.02A1.014 1.014 0 002.3 3.732l.019.022c.32.363.34.895.115 1.324a6.246 6.246 0 00-.435 1.047c-.145.463-.535.826-1.019.858l-.03.002a1.018 1.018 0 000 2.032l.03.002c.484.032.874.395 1.019.858.111.356.253.698.423 1.024.225.432.207.965-.11 1.335l-.022.026a1.028 1.028 0 001.45 1.45l.026-.023c.369-.317.902-.335 1.334-.11.326.17.668.312 1.024.423.463.145.826.535.858 1.019l.002.03a1.018 1.018 0 002.032 0l.002-.03c.032-.484.395-.874.858-1.019a6.24 6.24 0 001.029-.425c.43-.225.964-.208 1.332.11l.025.022a1.025 1.025 0 001.446-1.446l-.022-.025c-.318-.368-.335-.901-.11-1.332A6.24 6.24 0 0014 9.876c.145-.463.535-.826 1.019-.858l.03-.002a1.018 1.018 0 000-2.032l-.03-.002c-.484-.032-.874-.395-1.019-.858a6.248 6.248 0 00-.424-1.026c-.225-.432-.207-.965.11-1.334l.022-.025a1.026 1.026 0 00-1.447-1.448l-.026.022c-.37.317-.902.335-1.334.11a6.246 6.246 0 00-.995-.414c-.465-.148-.832-.537-.872-1.023L9.03.949A1.035 1.035 0 008 0zm0 11a3 3 0 100-6 3 3 0 000 6z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('warning') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M7.416 1.104L.88 14.32a.592.592 0 00.56.88h13.152a.624.624 0 00.56-.88L8.536 1.104a.664.664 0 00-1.12 0zm1.304 5.2H7.28v4.24h1.44v-4.24zm-1.44 5.04h1.44V12.8H7.28v-1.456z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('speech') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8 16a8 8 0 10-8-8v6.442a1 1 0 001.417.909l1.363-.625a1.08 1.08 0 011.016.081A7.962 7.962 0 008 16zm3-7v2H5V9h6zm0-2V5H5v2h6z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('thumb') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M9.404 4.831H14.419c.953 0 1.548.585 1.579 1.507a4.085 4.085 0 01-.41 1.933 165.973 165.973 0 00-1.897 4.123c-.288.645-.76.952-1.488.942-1.866-.01-3.733 0-5.6 0-.984 0-1.599-.585-1.599-1.537V5.495c0-.446.144-.832.462-1.16.605-.624 1.19-1.268 1.774-1.913a.774.774 0 00.164-.297c.123-.486.236-.981.349-1.467.133-.575.574-.793 1.128-.575.882.357 1.323 1.08 1.25 2.032-.071.853-.317 1.665-.625 2.458-.04.08-.072.159-.102.258zM1.333 9.084c0-1.08 0-2.15.01-3.231 0-.496.36-.882.862-1.001.462-.1.964.119 1.18.535.082.169.143.377.143.565.01 2.082.01 4.163 0 6.245 0 .605-.4 1.05-.964 1.12a1.09 1.09 0 01-1.19-.763c-.04-.13-.04-.278-.04-.417V9.084z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('bulb') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M10.69 10.898H5.365c-.053-.162-.128-.406-.224-.7-.096-.313-.117-.415-.15-.486-.148-.395-.404-.739-.724-1.063-1.47-1.449-1.96-3.17-1.331-5.085C3.563 1.64 5.012.464 7.09.09c3.25-.598 6.275 1.864 6.243 5.024-.01 1.286-.458 2.441-1.406 3.363-.373.364-.671.76-.863 1.195-.085.172-.192.598-.277.912-.043.131-.075.243-.096.314zM5.714 12.26h4.572c-.149.666-.257 1.321-.455 1.943-.158.48-.543.743-1.017.765-.543.022-1.076.022-1.619 0-.513-.022-.908-.317-1.066-.852-.178-.6-.277-1.223-.415-1.856z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }

                            @case ('star') {
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-is-decorative="true"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M10.406 5.33l3.187.305c1.108.107 1.448 1.19.592 1.901L11.691 9.61l.926 3.377c.304 1.11-.64 1.78-1.585 1.113l-3.03-2.14L4.97 14.1c-.94.665-1.888-.004-1.584-1.113l.926-3.377-2.494-2.074c-.86-.714-.521-1.794.592-1.9l3.186-.306 1.403-3.236c.44-1.014 1.565-1.013 2.005 0l1.402 3.236z"
                                        fill="currentColor"
                                    />
                                </svg>
                            }
                        }
                    </div>
                }

                <div class="top-banner__text" [innerHTML]="text"></div>

                <!-- TODO tech debt https://www.wrike.com/open.htm?id=769310637 -->
                @if (hasCloseButton) {
                    <button class="top-banner__close-button" (click)="closeBanner()">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            data-is-decorative="true"
                            aria-hidden="true"
                        >
                            <path
                                d="m4 4 8 8M4 12l8-8"
                                stroke="currentColor"
                                stroke-width="1.6"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                }
            </div>
        </div>
    </div>
}
